import React from 'react'
import {KTSVG} from '../../helpers'
import Flatpickr from 'react-flatpickr'
import {Turkish} from 'flatpickr/dist/l10n/tr.js'
import 'flatpickr/dist/flatpickr.css'

const Datepicker = ({...props}) => {
  return (
    <div className='position-relative d-flex align-items-center'>
      <KTSVG
        path='/images/icons/duotune/general/gen014.svg'
        className='svg-icon svg-icon-2 position-absolute mx-4'
      />
      <Flatpickr
        className='form-control form-control-solid ps-12'
        options={{locale: Turkish}}
        {...props}
      />
    </div>
  )
}

export {Datepicker}
